import React, {FC} from 'react';
import {TextField} from "@mui/material";
import {observer} from "mobx-react";
import {useStorageUserListContext} from "@app/modules/SelfConfig/contexts/storage";


type TProps = {
    // onChange(value: string)
}

export const UserLogin: FC<TProps> = observer((props: TProps) => {

    const {usersListStore} = useStorageUserListContext()


    return <TextField type={"login"}
                      label={"Login"}
                      name={"user-login"}
                      className={"editUser__login"}
                      autoComplete="off"
                      onChange={e => usersListStore.userLogin = e.target.value}
                      value={usersListStore.userLogin}
    />

})

